import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap, withLatestFrom } from 'rxjs/operators';
import { AnalyticsService } from 'src/core/services/analytics.service';
import { CartItem } from 'src/modules/cart/interfaces/cart.interface';
import { formatNumber } from 'src/util';

@Injectable()
export class AnalyticsEffects {
  addActions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType('[CART] ADD_CART_ITEM', '[CART] BATCH_ADD_CART_ITEM'),
        withLatestFrom(this.store.select('cart')),
        tap(
          ([action, cart]: [CartItem | { items: CartItem[] }, CartItem[]]) => {
            // 2 Varianten: cart neu erstellt, etwas zu cart hinzugefügt.
            // wann wird das cart neu erstellt? Wenn in action alle produkte sind die auch im cart sind
            let isNew = false;
            // @ts-expect-error inference leider kaputt :(
            const items: CartItem[] = action.items ? action.items : [action];
            if (
              items.length === cart.length &&
              items.length - cart.length === 0
            ) {
              // gleich lang, reicht wahrscheinlich als bedingung
              // bin aber pessimistisch
              let matchCount = 0;

              for (let i = 0; i < items.length; i++) {
                const found = cart.find(
                  (x) =>
                    x.productId === items[i].productId &&
                    x.quantity === items[i].quantity
                );
                if (found) {
                  matchCount++;
                }
              }

              if (matchCount === items.length) {
                isNew = true;
              }
            }

            const value = cart.reduce(
              (acc, x) => acc + x.price * x.quantity,
              0
            );
            this.analytics.trackEventWithCurrency({
              event: 'digital bag',
              action: isNew ? 'create' : 'update - add',
              cartValue: formatNumber(value),
              category: 'bpl app',
            });
          }
        )
      ),
    { dispatch: false }
  );
  removeActions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType('[CART] REMOVE_CART_ITEM'),
        withLatestFrom(this.store.select('cart')),
        tap(([action, cart]) => {
          const value = cart.reduce((acc, x) => acc + x.price * x.quantity, 0);
          this.analytics.trackEventWithCurrency({
            event: 'digital bag',
            action: 'update - remove',
            cartValue: formatNumber(value),
            category: 'bpl app',
          });
        })
      ),
    { dispatch: false }
  );
  emptyActions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType('[CART] EMPTY_CART'),
        withLatestFrom(this.store.select('cart')),
        tap(() => {
          this.analytics.trackEventWithCurrency({
            event: 'digital bag',
            action: 'update - empty',
            cartValue: 0.0,
            category: 'bpl app',
          });
        })
      ),
    { dispatch: false }
  );
  updateActions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType('[CART] UPDATE_CART_ITEM', '[CART] BATCH_Update_CART_ITEM'),
        withLatestFrom(this.store.select('cart')),
        tap(
          ([action, cart]: [
            (
              | { item: CartItem; didAddProduct: boolean }
              | { items: CartItem[]; didAddProduct: boolean }
            ),
            CartItem[]
          ]) => {
            const value = cart.reduce(
              (acc, x) => acc + x.price * x.quantity,
              0
            );
            this.analytics.trackEventWithCurrency({
              event: 'digital bag',
              action: action.didAddProduct ? 'update - add' : 'update - remove',
              cartValue: formatNumber(value),
              category: 'bpl app',
            });
          }
        )
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private store: Store<{ cart: CartItem[] }>,
    private analytics: AnalyticsService
  ) {}
}
